import { CharacterCount } from './components/CharacterCount';
import * as React from 'react';
import { EditorContent } from '@tiptap/react';
import { Box } from '@chakra-ui/react';
import { MenuBar } from './components/MenuBar';
import { useEditorContext, withEditorContext } from './editor_context';

const TiptapEditorComponent = () => {
   const { editor } = useEditorContext();
   const isFocused = editor.view.hasFocus();

   return (
      <>
         <Box className="ProseMirror-menubar-wrapper">
            <MenuBar />
            <EditorContent editor={editor} />
         </Box>
         {isFocused ? <CharacterCount /> : null}
      </>
   );
};

export const TiptapEditor = withEditorContext(TiptapEditorComponent);
